<template>
  <div class="tabbar-container">
    <van-tabbar route>
      <van-tabbar-item replace to="/agency/adApply" icon="home-o">
        <span>广告申请</span>
        <template #icon>
          <img :src="require('../assets/apply.png')" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/agency/history" icon="search">
        <span>历史记录</span>
        <template #icon>
          <img :src="require('../assets/history.png')" />
        </template>
      </van-tabbar-item>
      <!-- <van-tabbar-item replace to="/agency/reimbursement" icon="friends-o">
        <span>广告报销</span>
        <template #icon>
          <img :src="require('../assets/reimbursement.png')" />
        </template>
      </van-tabbar-item> -->
    </van-tabbar>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.tabbar-container {
  .van-tabbar {
    z-index: 101;
    box-shadow: 0 0 20px -10px black;
  }
}
</style>
